export const enSidebarTranslation = {
  sidebar: {
    home: 'Home',
    your_data: {
      title: 'Your Data',
      company_data: 'Company Data',
      meritocracy_policies: 'Meritocracy Policies',
      staff_data: 'Staff Data',
      grades: 'Grades',
      salary_grade: 'Salary Scale',
      salary_scale_by_position: 'Salary Table by Position',
    },
    job_structure: {
      title: 'Job Structure',
      matrix_creation: 'Matrix Creation',
      matrix_view: 'Matrix View',
      job_mapping: 'Job Mapping',
      job_description: 'Job Description',
    },
    remuneration_strategy: {
      title: 'Compensation Strategy',
      salary_tables: 'Salary Tables',
      framing_cost: 'Framing Cost',
      market_data: 'Market Data',
      competitiveness_analysis: 'Competitiveness Analysis',
      incentive_targets: 'Incentive Targets',
    },
    dashboard: {
      title: 'Compensation Dashboard',
      employees: 'Employees',
      company: 'Company',
    },
    meritocracy: {
      title: 'Meritocracy',
      simulations: 'Simulations',
      parameters: 'Parameters',
    },
    central_upload: {
      title: 'Upload Center',
      upload: 'Upload',
      history: 'History',
    },
    access_control: {
      title: 'Access Control',
    },
  },
};
